import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import FormInputField from 'components/Shared/FormInputField';
import FormControlCheckbox from 'components/Shared/FormControlCheckbox';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import LabeledSwitcher from 'components/Shared/LabeledSwitcher';
import Link from '@material-ui/core/Link';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ReactComponent as GoogleIcon } from 'assets/google.svg';

import { motionRedirectLinks } from 'components/Register/RegisterConstants';
import { PASSWORD_VALIDATION_MESSAGES } from 'constants/commonConstants';
import { UI_VIEWS } from 'constants/authConstants';
import { ROLES } from 'constants/userConstants';

const RegisterAgencyCandidateFormView = ({
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    isActionButtonLoading,
    ssoLoginLoading,
    handleSSOSignIn,
    selectedView,
    setSelectedView,
}) => {
    const isNameRequirementNotMet = errors.name && touched.name;

    const isEmailRequirementNotMet = errors.email && touched.email;

    const isPasswordRequirementMet = !errors.password && values.password;
    const isPasswordRequirementNotMet = errors.password && touched.password;

    const isTCChecked = values.isTermsAndConditionsAccepted;
    const hasTCError = errors.isTermsAndConditionsAccepted;
    const isTCFieldTouched = touched.isTermsAndConditionsAccepted;

    return (
        <form autoComplete="off">
            <LabeledSwitcher
                options={Object.values(UI_VIEWS)}
                selectedOption={selectedView}
                setSelectedOption={setSelectedView}
            />

            <FormInputField
                className="smaller"
                label="Name"
                placeholder="Name"
                name="name"
                value={values.name}
                showValidationRequirement={isNameRequirementNotMet}
                requirementText={errors.name}
                isRequirementNotMet={isNameRequirementNotMet}
                handleChange={handleChange}
                handleBlur={handleBlur}
            />

            <FormInputField
                className="smaller"
                label="Email"
                placeholder="Email"
                name="email"
                value={values.email}
                showValidationRequirement={isEmailRequirementNotMet}
                requirementText={errors.email}
                isRequirementNotMet={isEmailRequirementNotMet}
                handleChange={handleChange}
                handleBlur={handleBlur}
            />

            <FormInputField
                className="smaller"
                withPasswordVisibility
                label="Password"
                placeholder="Password"
                name="password"
                value={values.password}
                showValidationRequirement
                requirementText={PASSWORD_VALIDATION_MESSAGES.ALL}
                isRequirementMet={isPasswordRequirementMet}
                isRequirementNotMet={isPasswordRequirementNotMet}
                handleChange={handleChange}
                handleBlur={handleBlur}
            />

            <FormControlCheckbox
                isTouched={isTCFieldTouched}
                hasError={hasTCError}
                name="isTermsAndConditionsAccepted"
                label={
                    <span>
                        I agree to the platform's <a className={selectedView.ROLE} href={motionRedirectLinks.privacy.link} target="_blank">{motionRedirectLinks.privacy.label}.</a>
                    </span>
                }
                checked={isTCChecked}
                handleChange={() => setFieldValue('isTermsAndConditionsAccepted', !isTCChecked)}
            />

            <div className="buttons-wrapper">
                <ActionButton
                    text={isActionButtonLoading ? <CircularProgress thickness={5} className="white" /> : "Sign Up"}
                    handleClick={handleSubmit}
                    className={selectedView.ROLE === ROLES.CANDIDATE ? "purple" : "orange"}
                />

                <ActionButton
                    className="inverted with-icon"
                    text={ssoLoginLoading ? "Sign In With Google" : <CircularProgress thickness={5} className="teal" />}
                    icon={ssoLoginLoading && <GoogleIcon />}
                    handleClick={handleSSOSignIn}
                />
            </div>

            <p className="login-text-wrapper">
                Already have an account? <Link
                    underline="always"
                    className={selectedView.ROLE}
                    component={RouterLink}
                    to={{pathname: motionRedirectLinks.login.link, state: { selectedView }}}
                >
                    {motionRedirectLinks.login.label}
                </Link>
            </p>
        </form>
    )
}
export default RegisterAgencyCandidateFormView;
